/**
 * Cookie / tracking consent store (Consent Mode placeholder).
 * Only the visitor's consent choice is persisted — never lead data.
 */

export type ConsentState = 'granted' | 'denied' | 'unset'

const STORAGE_KEY = 'vero_consent_v1'

let current: ConsentState = 'unset'
const listeners = new Set<(state: ConsentState) => void>()

function read(): ConsentState {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return stored === 'granted' || stored === 'denied' ? stored : 'unset'
  } catch {
    return 'unset'
  }
}

export function initConsent(): ConsentState {
  current = read()
  return current
}

export function getConsent(): ConsentState {
  return current
}

export function setConsent(next: Exclude<ConsentState, 'unset'>): void {
  current = next
  try {
    window.localStorage.setItem(STORAGE_KEY, next)
  } catch {
    /* storage unavailable — consent stays session-only */
  }
  // Consent Mode placeholder: forward the update to the tag manager once
  // real measurement IDs are configured server-side.
  listeners.forEach((listener) => listener(next))
}

export function subscribeConsent(listener: (state: ConsentState) => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
